<template>
  <div style="padding: 5px">
    <div class="menu">
      <header>
        <h2>{{ $t('role.title') }}</h2>
        <a-space>
          <a-button type="primary" @click="handleSearch" v-if="authorities.find(a => a.code === 'auth:role:query')">{{ $t('buttons.search') }}</a-button>
          <a-button
            type="primary"
            @click="$router.push('/system/permission')"
            v-if="authorities.find(a => a.code === 'auth:role:insert')"
          >{{ $t('buttons.add') }}</a-button>
          <a-button @click="showClipboard">{{ $t('role.clipboard') }}</a-button>
        </a-space>
      </header>
      <a-table
        :columns="columns"
        :data-source="data"
        :row-key="record => record.id"
        :pagination="pagination"
        :loading="isLoading"
        :scroll="scroll"
        @change="handleTableChange"
      >
        <template v-slot:detailsName="text">
          <text-highlight :queries="[highLightInfo['details.name']]">{{text}}</text-highlight>
        </template>
        <template v-slot:pid="text">{{ pids[text] }}</template>
        <template v-slot:icon="text">
          <a-icon :type="text" style="font-size: 20px" />
        </template>
        <template v-slot:enabled="text">{{ text ? $t('common.yes') : $t('common.no') }}</template>
        <template #operation="text, record">
          <a-button
            type="link"
            style="padding-left: 0"
            @click="$router.push({ path: '/system/permission', query: { pid: record.id } })"
            v-if="authorities.find(a => a.code === 'auth:role:insert')"
          >{{ $t('buttons.add') }}</a-button>
          <a-button
            type="link"
            style="padding-left: 0"
            @click="$router.push({ path: '/system/permission', query: { id: record.id } })"
            v-if="authorities.find(a => a.code === 'auth:role:update')"
          >{{ $t('buttons.edit') }}</a-button>
          <a-popconfirm
            :key="lang"
            v-if="authorities.find(a => a.code === 'auth:role:delete')"
            :title="$t('messages.ctrd')"
            :ok-text="$t('common.okText')"
            :cancel-text="$t('common.cancelText')"
            @confirm="removeRole(record)"
          >
            <a href="#">{{ $t('buttons.delete') }}</a>
          </a-popconfirm>
          <a-button type="link" style="padding-left: 0; margin-left: 15px" @click="copyRole(record)">{{ $t('role.copy') }}</a-button>
        </template>
      </a-table>
      <a-modal @ok="isClipboardShow = false" :title="$t('role.clipboard')" v-model="isClipboardShow">
        <a-list item-layout="horizontal" :data-source="clipboardList">
          <a-list-item slot="renderItem" slot-scope="item">
            <div style="position: relative; width: 100%">
              {{ item.name }}<a-icon @click="removeClip(item)" type="close" style="position: absolute; right: 0; top: 50%; transform: translateY(-50%); cursor: pointer" />
            </div>
          </a-list-item>
        </a-list>
      </a-modal>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { getMenuList, getAllMenuList } from "@/api/auth/menu";
import {
  getRoleList,
  getRole,
  searchRoleList,
  addRole,
  updateRole,
  removeRole
} from "@/api/auth/role";
import TextHighlight from "vue-text-highlight";
import { getDict } from '@/api/dict'

export default {
  components: { TextHighlight },
  data() {
    return {
      expandedKeys: [-1],
      highLightInfo: {
        "details.name": ""
      },
      isClipboardShow: false,
      autoExpandParent: true,
      checkedKeys: [],
      selectedKeys: [],
      treeData: [],
      data: [],
      authorities: [],
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      visible: false,
      isLoading: false,
      columns: [
        {
          title: () => (
            <div>
              { this.$t('role.columns.name') }
              <a-input class="search" allow-clear type="text" data-index="0" />
            </div>
          ),
          dataIndex: "zh-CN",
          key: "details.name",
          scopedSlots: {
            customRender: "detailsName"
          }
        },
        {
          title: () => this.$t('role.columns.privilegeLevel'),
          dataIndex: "privilegeLevel",
          key: "privilegeLevel"
        },
        // {
        //   title: '父级角色',
        //   dataIndex: 'pid',
        //   key: 'pid',
        //   scopedSlots: {
        //     customRender: 'pid'
        //   }
        // },
        {
          title: () => (
            <div>
              { this.$t('common.createdAt') }
              <span
                class="icons unset"
                style="cursor: pointer; right: -52px"
                data-index="2"
              >
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </span>
            </div>
          ),
          dataIndex: "createdAt",
          width: "30%",
          key: "createdAt"
        },
        {
          title: () => (
            <div>
              { this.$t('common.updatedAt') }
              <span
                class="icons DESC"
                style="cursor: pointer; right: -52px"
                data-index="3"
              >
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </span>
            </div>
          ),
          dataIndex: "updatedAt",
          key: "updatedAt"
        },
        {
          title: () => this.$t('role.columns.enabled'),
          dataIndex: "enabled",
          key: "enabled",
          scopedSlots: {
            customRender: "enabled"
          }
        },
        {
          title: () => this.$t('common.operation'),
          dataIndex: "operation",
          key: "operation",
          align: "left",
          scopedSlots: { customRender: "operation" },
          fixed: 'right'
        }
      ],
      pagination: {
        current: 1,
        pageSize: 100,
        total: 0
      },
      pids: {
        0: "无"
      },
      sortInfo: [],
      searchInfo: {
        text: {
          protocolCode: "",
          protocolName: ""
        },
        column: {
          protocolCode: false,
          protocolName: false
        }
      },
      state: "add",
      menus: [],
      title: "新增角色",
      deviceTypeList: [],
      form: {
        pid: "0",
        code: null,
        enabled: true,
        dataScope: "",
        menus: [],
        details: [
          {
            name: "",
            description: null,
            locale: "zh-CN"
          },
          {
            name: "",
            description: null,
            locale: "en-US"
          }
        ],
        "zh-CN": "",
        "en-US": "",
        allowSelectDeviceType: ""
      },
      selectedDeviceTypeList: [],
      rules: {
        pid: [
          {
            required: true,
            message: "请选择父级角色"
          }
        ],
        "zh-CN": [
          {
            required: true,
            message: "请输入角色名称",
            trigger: "blur"
          }
        ],
        dataScope: [
          {
            required: true,
            message: "请输入权限等级",
            trigger: "blur"
          }
        ]
      },
      authorities: [],
      ids: {},
      scroll: {
        x: false
      },
      clipboardList: []
    };
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  created() {
    this.queryParams = {
      query: [],
      filter: [
        {
          field: "pid",
          value: 0
        }
      ],
      sort: [
        {
          field: "updatedAt",
          value: "DESC"
        }
      ]
    };
    this.getDictList()
  },
  activated() {
    const a = JSON.parse(sessionStorage.getItem('authorities'))
    if (a?.length) {
      this.authorities = a
    } else {
      this.authorities = this.getAuthorities(this.$route.path)
    }
  },
  async mounted() {
    this.getRoleList();
    this.getMenuList();
    const menus = await getAllMenuList();
    this.setMenusToTree(menus);
    const ss = document.querySelectorAll(
      ".ant-table-column-title > div span.icons"
    );
    ss.forEach(i => {
      i.addEventListener("click", () => {
        let c = "";
        switch (i.classList[1]) {
          case "ASC":
            c = "DESC";
            break;
          case "DESC":
            c = "unset";
            break;
          case "unset":
            c = "ASC";
            break;
          default:
            break;
        }
        i.classList.remove(i.classList[1]);
        i.classList.add(c);
        const ii = document.querySelectorAll(
          ".ant-table-column-title > div span.icons:not(.unset)"
        );
        const sort = Array.from(ii).map(item => {
          const index = +item.dataset["index"];
          return {
            field: this.columns[index].key,
            value: item.classList[1]
          };
        });
        this.queryParams.sort = sort;
        this.searchRoleList();
      });
    });
    const ips = document.querySelectorAll(".search .ant-input");
    ips.forEach(ip => {
      ip.addEventListener("keyup", ({ key, target }) => {
        // console.log(key, target.value.trim())
        if (key === "Enter") {
          target.value = target.value.trim()
          // target.value.trim() && this.handleSearch()
          this.handleSearch();
        }
      });
      ip.addEventListener('blur', ({ target }) => {
        target.value = target.value.trim()
      })
    });
    const width = window.innerWidth
    if (width < 1600) {
      this.scroll.x = 1350
    } else if (width < 1900) {
      this.scroll.x = 1647
    } else {
      this.scroll.x = false
    }
  },
  methods: {
    getDictList() {
      getDict('zh-CN', 'deviceType').then(({ data }) => {
        this.deviceTypeList = data.content
      })
    },
    async getRoleList() {
      this.searchRoleList();
    },
    onCheck(checkedKeys) {
      console.log(checkedKeys);
      checkedKeys.forEach(c => {
        const i = this.c.find(cc => cc == c)
        if (!i) {
          console.log(c)
        }
      })
      this.checkedKeys = checkedKeys;
    },
    async getMenuList() {
      let res = await getMenuList(1, 100);
      if (res.data.total > 100) {
        res = await getMenuList(1, res.data.total);
      }
      this.menus = res.data.records;
    },
    async handleSearch() {
      this.pagination.current = 1;
      const ips = document.querySelectorAll(".search .ant-input");
      this.queryParams.query = [];
      ips.forEach(ip => {
        if (ip.value.trim()) {
          this.queryParams.filter = [];
          this.queryParams.query.push({
            field: this.columns[+ip.dataset["index"]].key,
            value: ip.value
          });
          this.highLightInfo[this.columns[+ip.dataset["index"]].key] = ip.value;
        } else {
          this.queryParams.filter = [
            {
              field: "pid",
              value: 0
            }
          ];
          this.highLightInfo[this.columns[+ip.dataset["index"]].key] = "";
        }
      });
      this.searchRoleList();
    },
    async searchRoleList(callback) {
      this.isLoading = true;
      try {
        const { data } = await searchRoleList(
          this.pagination.current,
          this.pagination.pageSize,
          this.queryParams
        );
        // this.data = data.records
        // .map(item => {
        //   // this.pids[item.id] = item.details[1].name
        //   item.createdAt = moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')
        //   item.updatedAt = moment(item.updatedAt).format('YYYY-MM-DD HH:mm:ss')
        //   return item
        // })
        for (let i = 0; i < data.records.length; i++) {
          this.setTreeData(data.records[i]);
        }
        console.log(data.records);
        this.data = data.records;
        if (callback) {
          this.search = true;
          await callback();
          this.pagination.current = data.current;
          this.pagination.total = data.total;
        } else {
          this.pagination.current = data.current;
          this.pagination.total = data.total;
        }
      } finally {
        this.isLoading = false;
      }
    },
    async handleReset(clearFilters, dataIndex) {
      clearFilters();
      this.searchInfo.text[dataIndex] = "";
      this.searchInfo.column[dataIndex] = false;
      this.query.query[0].value = "";
      this.searchRoleList();
    },
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    onSelect(selectedKeys, info) {
      console.log("onSelect", info);
      this.selectedKeys = selectedKeys;
    },
    async removeRole(record) {
      try {
        const { message } = await removeRole(record.id);
        this.$message.success(message);
        if (this.data.length === 1 && this.data[0].id === record.id) {
          this.pagination.current =
            this.pagination.current === 1 ? 1 : this.pagination.current - 1;
        }
        this.searchRoleList();
      } catch (e) {
        console.log(e);
        this.$message.error(this.$t('messages.ftd'))
      }
    },
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            const form = { ...this.form, pid: +this.form.pid };
            // console.log(form);
            // console.log(this.checkedKeys);
            const menus = {};
            // menus: {
            //   5: [
            //     {
            //       id: 1
            //     }
            //   ]
            // }
            form.details[0] = {
              locale: "zh-CN",
              name: form["zh-CN"],
              description: null
            };
            form.details[1] = {
              locale: "en-US",
              name: form["en-US"],
              description: null
            };
            delete form["zh-CN"];
            delete form["en-US"];

            console.log(this.checkedKeys);
            console.log(this.menus);
            this.checkedKeys.forEach(i => {
              if (typeof i == 'number') {
                if (!menus[i]) {
                  menus[i] = []
                }
              }

              if (typeof i == 'string') {
                const ids = i.split('-')
                if (!menus[ids[0]]) {
                  menus[ids[0]] = []
                }
                menus[ids[0]].push({
                  id: ids[1]
                })
              }
            })

            delete menus["-1"]
            // this.menus.forEach(m => {
            //   if (menus[m.id])
            // })
            console.log(menus);
            for (let i = 0; i < this.menus.length; i++) {
              if (menus[this.menus[i].id]) {
                continue
              }
              if (this.menus[i].children?.length) {
                for (let j = 0; j < this.menus[i].children.length; j++) {
                  console.log(this.menus[i].children[j].id);
                  if (menus[this.menus[i].children[j].id]) {
                    menus[this.menus[i].id] = []
                    break
                  }
                }
              }
            }
            form.menus = Object.entries(menus).map(([key, value]) => {
              return {
                id: +key,
                authorities: value
              }
            })
            form.menus = form.menus.concat(this.mobileMenu)
            console.log(form.menus);
            console.log(this.selectedDeviceTypeList);
            form.allowSelectDeviceType = this.selectedDeviceTypeList + ''
            if (this.form.id) {
              const { message } = await updateRole(form);
              this.$message.success(message);
            } else {
              const { message } = await addRole(form);
              this.$message.success(message);
            }
            this.getRoleList();
            this.visible = false;
            this.clearForm();
          } catch (e) {
            console.log(e);
          }
        } else {
          this.$message.warn("表单校验不通过");
        }
      });
    },
    async showEditModal(record) {
      this.state = "edit";
      const { data } = await getRole(record.id);
      const c = [];
      this.menu = data.menus
      data.menus.forEach(item => {
        if (item.id) {
          if (item.pid === 0 && ![7].includes(item.id)) {
            return;
          }
          if ([17, 46].includes(item.id)) {
            c.push(item.id);
          } else {
            if (item.authorities && item.authorities.length > 0) {
              if (item.authorities.length === 4) {
                c.push(item.id);
              }
              item.authorities.forEach(a => {
                c.push(item.id + "-" + a.id);
              });
            } else {
              c.push(item.id);
            }
          }
        }
      });
      this.checkedKeys = c;
      this.c = [...c]
      console.log(c);
      this.title = "编辑角色";
      record.details.forEach(d => {
        record[d.locale] = d.name;
      });
      console.log(record.details);
      if (!record["zh-CN"]) {
        record["zh-CN"] = record["en-US"];
      }
      if (!record.menus) {
        record.menus = [];
      }
      for (let key in this.form) {
        if (key === "pid") {
          this.form[key] = record[key] + "";
        } else {
          this.form[key] = record[key];
        }
      }
      this.selectedDeviceTypeList = record.allowSelectDeviceType.split(',')
      this.form.id = record.id;
      this.visible = true;
    },
    clearForm() {
      this.visible = false;
      this.checkedKeys = [];
      this.form = {
        pid: "0",
        code: null,
        enabled: true,
        dataScope: "",
        menus: [],
        details: [
          {
            name: "",
            description: null,
            locale: "zh-CN"
          },
          {
            name: "",
            description: null,
            locale: "en-US"
          }
        ],
        "zh-CN": "",
        "en-US": ""
      };
    },
    handleTableChange(pagination) {
      this.pagination = pagination;
      this.searchRoleList();
    },
    setMenusToTree(menus) {
      const treeData = {
        title: "菜单",
        key: -1,
        children: []
      };
      console.log(menus.data);
      this.mobileMenu = []
      this.menus = menus.data
    
      menus.data.forEach(menu => {
        if (menu.isMobile !== 1) {
          const o = {
            title: menu.details[0].name,
            key: menu.id,
            children: []
          };
          this.expandedKeys.push(menu.id);
          if (menu.children.length > 0) {
            if (menu.routeName === "Warning") {
              menu.children.forEach(i => {
                i.children = null;
                o.children.push({
                  title: i.details[0].name,
                  key: i.id
                });
              });
            } else {
              menu.children.forEach(item => {
                const oo = {
                  title: item.details[0].name,
                  key: item.id
                };
                this.expandedKeys.push(oo.key);
                oo.children = item.authorities.map(a => {
                  return {
                    title: a.details[0].name,
                    key: oo.key + "-" + a.id
                  };
                });
                o.children.push(oo);
              });
            }
          } else if (menu.authorities.length > 0) {
            if (menu.routeName === "Overview") {
              o.children = null;
            } else {
              o.children = menu.authorities.map(a => {
                return {
                  title: a.details[0].name,
                  key: o.key + "-" + a.id
                };
              });
            }
          }
          treeData.children.push(o);
        } else {
          this.mobileMenu.push({
            id: menu.id,
            authorities: []
          })
        }
      });
      this.treeData = [treeData];
    },
    setTreeData(item) {
      item.createdAt = moment(item.createdAt).format("YYYY-MM-DD HH:mm:ss");
      item.updatedAt = moment(item.updatedAt).format("YYYY-MM-DD HH:mm:ss");
      item.details.forEach(d => {
        item[d.locale] = d.name;
      });
      if (!item["zh-CN"]) {
        item["zh-CN"] = item["en-US"];
      }
      this.pids[item.id] = item["zh-CN"];
      if (item.children && item.children.length) {
        for (let i = 0; i < item.children.length; i++) {
          this.setTreeData(item.children[i]);
        }
      } else {
        item.children = null;
      }
    },
    showClipboard() {
      this.isClipboardShow = true
    },
    copyRole(r) {
      if (!this.clipboardList.find(c => c.id === r.id)) {
        this.clipboardList.push({
          name: r['zh-CN'],
          id: r.id
        })
        this.$store.commit('setClipboard', this.clipboardList)
      }
    },
    removeClip(r) {
      const index = this.clipboardList.findIndex(c => c.id === r.id)
      if (index > -1) {
        this.clipboardList.splice(index, 1)
        this.$store.commit('setClipboard', this.clipboardList)
      }
    }
  }
};
</script>

<style lang="less" scoped>
.menu {
  margin: 20px;
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.row {
  margin-top: 5px;
}
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
.ant-table-column-title span {
  position: relative;
}
.ant-table-column-title .anticon-caret-up {
  position: absolute;
  top: -1px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
.ant-table-column-title span.ASC .anticon-caret-up {
  color: #1890ff;
}
.ant-table-column-title span.DESC .anticon-caret-down {
  color: #1890ff;
}
.ant-table-column-title .anticon-caret-down {
  position: absolute;
  top: 8px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
.ant-table-column-title div {
  position: relative;
}
.ant-table-column-title span {
  position: relative;
}
.ant-table-column-title .anticon-caret-up {
  position: absolute;
  top: -1px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
.ant-table-column-title span.ASC .anticon-caret-up {
  color: #1890ff;
}
.ant-table-column-title span.icons {
  position: absolute;
  right: 18px;
}
.ant-table-column-title span.DESC .anticon-caret-down {
  color: #1890ff;
}
.ant-table-column-title .anticon-caret-down {
  position: absolute;
  top: 8px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
</style>